
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/markets",
      function () {
        return require("private-next-pages/dashboard/markets.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/markets"])
      });
    }
  